import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaArrowUp } from 'react-icons/fa';

import { Odom } from '../../HomePage/components/Highlights';
import oneTwentyNine from '../../../assets/images/oneTwentyNine.png';

const BeyondPaperGraphics = () => (

  <Container fluid>
    <Row>
      <Col xs={12} sm={6} md={3}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <FourHundo />
        </Row>
      </Col>
      <Col xs={12} sm={6}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <OneTwentyNine />
        </Row>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <EightHundo />
        </Row>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <NinetyFourPercent />
        </Row>
      </Col>
      <Col xs={12} md={6}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <EightProvinces />
        </Row>
      </Col>
      <Col xs={12} md={3}>
        <Row style={{ height: '100%', paddingRight: 10, paddingLeft: 10 }}>
          <EightBrokerManagement />
        </Row>
      </Col>
    </Row>
  </Container>
)

const FourHundo = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row style={{
      display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'flex-start'
    }}>
      <Odom number={400} text="%"
        style={{ justifyContent: 'flex-end' }}
        odomStyle={{
          fontSize: 28,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#1B526D',
          lineHeight: 1,
          padding: 0,
        }} />
      <Col>
        <FaArrowUp
          size={28}
          color='#1B526D'
        />
      </Col>

    </Row>
    <Row>
      <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2
      }}>
        <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>eSlips </span> and <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>policy documents sent digitally</span>, over 2019
      </p>

    </Row>
  </Col>
)

const OneTwentyNine = () => (
  <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
    <Row>
      <Col xs={8}>
        <Row>
          <Odom
            xs={5}
            number={129} text="%"
            style={{ justifyContent: 'flex-start', paddingLeft: 20, paddingRight: 0 }}
            odomStyle={{
              fontSize: 28,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1B526D',
              padding: 0,
            }}
            textStyle={{
              marginTop: 8,
              fontSize: 28,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#1B526D',
              padding: 0,
            }}
          />
          <Col xs={7} style={{ paddingLeft: 0, paddingTop: 6}}>
            <FaArrowUp
              size={28}
              color='#1B526D'
            />
          </Col>
        </Row>
        <Row>
          <p style={{
            fontSize: 18,
            fontFamily: 'montserrat medium',
            // fontWeight: 'bold',
            color: '#4D788D',
            padding: 0,
            paddingLeft: 20,
            paddingRight: 20,
            lineHeight: 1.2,
          }}>
            new visitors to <span style={{
              fontSize: 18,
              fontFamily: 'montserrat bold',
              fontWeight: 'bold',
              color: '#14183A',
              padding: 0,
            }}>MyProofofinsurance.ca</span>
          </p>

        </Row>
      </Col>
      <Col>
        <img
          src={oneTwentyNine}
          style={{
            width: '100%',
            height: 'auto'
          }}
          alt=""
        />
      </Col>
    </Row>
  </Col>
)

const EightHundo = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row>
      <Odom number={800} text="+" odomStyle={{
        fontSize: 28,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        lineHeight: 1,
        padding: 0,
      }} />
    </Row>
    <Row style={{
      fontSize: 18,
      fontFamily: 'montserrat medium',
      // fontWeight: 'bold',
      color: '#4D788D',
      lineHeight: 1,
      padding: 0,
      paddingLeft: 20,
      paddingRight: 20,
    }}>
      <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2,
      }}>
        brokerages have <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>adopted My Proof of Insurance</span>
      </p>

    </Row>
  </Col>
)

const NinetyFourPercent = () => (
  <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
    <Row>
      <Odom number={94} text="%" odomStyle={{
        fontSize: 28,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        lineHeight: 1,
        padding: 0,
      }} />
    </Row>
    <Row>
      <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2,
      }}>
        <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>satisfaction</span> with <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>MPOI,</span> up from 87% in 2019
    </p>

    </Row>
  </Col>
)

const EightProvinces = () => (
  <Col style={{ marginTop: 20, padding: 20 }}>
    <Row>
      <Odom number={8} text="" odomStyle={{
        fontSize: 28,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        lineHeight: 1,
        padding: 0,
      }} />
    </Row>
    <Row style={{
      fontSize: 18,
      fontFamily: 'montserrat medium',
      // fontWeight: 'bold',
      color: '#4D788D',
      padding: 0,
      paddingLeft: 20,
      paddingRight: 20,
    }}>
      <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
        lineHeight: 1.2,
      }}>
        <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
          padding: 0,
        }}>provinces/territories have now approved eSlips:</span> Alberta, Ontario, Nova Scotia, Quebec, Newfoundland, & Labrador, Prince Edward Island, Northwest Territories, Yukon Territory
      </p>

    </Row>
  </Col>
)

const EightBrokerManagement = () => (
  <Col style={{ backgroundColor: '#F3F5ED', marginTop: 20, padding: 20 }}>
    <Row>
      <Odom number={8} odomStyle={{
        fontSize: 28,
        fontFamily: 'montserrat bold',
        fontWeight: 'bold',
        color: '#1B526D',
        lineHeight: 1,
        padding: 0,
      }} />
    </Row>
    <Row>
      <p style={{
        fontSize: 18,
        fontFamily: 'montserrat medium',
        // fontWeight: 'bold',
        color: '#4D788D',
        lineHeight: 1.2,
        padding: 0,
        paddingLeft: 20,
        paddingRight: 20,
      }}>
        Broker Management Systems <span style={{
          fontSize: 18,
          fontFamily: 'montserrat bold',
          fontWeight: 'bold',
          color: '#14183A',
        }}>(BMS) integrate with MPOI</span>
      </p>
    </Row>
  </Col>
)

export default BeyondPaperGraphics;
